import { ExtendedDataNode } from 'components/atoms';
import { CoreCurriculumDTO, CoreCurriculumName, SelectOptionType } from 'types';

export const mapCoreCurriculumListToCoreCurriculumNamesList = (
    coreCurriculumData: CoreCurriculumDTO[],
): CoreCurriculumName[] =>
    coreCurriculumData.flatMap((section) => section.points.map((point) => point.name));

export const mapCoreCurriculumListToSelectOptionsList = (
    coreCurriculumData: CoreCurriculumDTO[],
): SelectOptionType<CoreCurriculumName, string>[] =>
    coreCurriculumData.flatMap((section) =>
        section.points.map((point) => ({
            value: point.name,
            label: point.displayName,
        })),
    );

export const coreCurriculumListToTreeReducer = (
    acc: ExtendedDataNode[],
    currentCoreCurriculum: CoreCurriculumDTO,
) => {
    const coreCurriculumPoints = currentCoreCurriculum.points.map((point) => ({
        title: `${point.displayName}. ${point.description}`,
        key: point.name,
    }));

    return acc.concat({
        title: `${currentCoreCurriculum.number}. ${currentCoreCurriculum.title}`,
        key: currentCoreCurriculum.number,
        children: coreCurriculumPoints,
    });
};

export const parseCoreCurriculumDataToTreeNodes = (coreCurriculumData: CoreCurriculumDTO[]) =>
    coreCurriculumData.reduce<ExtendedDataNode[]>(coreCurriculumListToTreeReducer, []);
